// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";

import { isCalculatedAttributeDetail } from "../apiCalculatedAttributesAppGroupId";

export const isGetApiCalculatedAttributesIdAppGroupIdResult = objectOf({
  calculated_attribute: isCalculatedAttributeDetail,
});

export const isPutApiCalculatedAttributesIdAppGroupIdResult = objectOf({
  calculated_attribute: isCalculatedAttributeDetail,
});
